import { AdminPanelV2 } from '@/features/adminPanel/components/AdminPanelV2';
import { AdminPanelLayoutV2 } from '@/features/adminPanel/components/AdminPanelLayoutV2';

export const AdminPanelPage = () => {
  return (
    <AdminPanelLayoutV2
      title='Panel administrativo'
      subtitle='Configura los elementos que controlan la operación del sistema'
    >
      <AdminPanelV2 />
    </AdminPanelLayoutV2>
  );
};